<template>
  <div v-if="cart && cart.cart_items && cart.cart_items.length" class="calendarCartHeader tempus-iframe-500-container table-striped" ref="cartSummaryHeader" id="cartSummaryHeader">
    <div class="container py-4">
      <h4 class="mt-2 ml-2 heading">Your Cart Summary&hellip;</h4>
      <table class="calendarCartHeaderTable table-striped">
        <tbody>
          <template v-for="cartItem in sortedCartItems">
            <tr :key="cartItem.id" :ref="'cartItemRow' + cartItem.id" class="vld-parent">
              <template v-if="($mq == 'xs' || $mq == 'sm' || $mq == 'md')">
                <td style="vertical-align: top; min-width: 160px" class="text-left">

                  <div style="vertical-align: top;">
                    <p class="mb-0">
                      <template v-if="cartItem.cartable_type == 'App\\Models\\Product'">
                        <template v-if="cartItem.descriptionShort == 'Booking fee'">
                          Booking Fee
                        </template>
                        <template v-else>
                          AddOn: {{ cartItem.descriptionShort }}
                        </template>
                      </template>
                      <template v-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct' && cartItem.description == 'Money Voucher for 1p'">Money Voucher for {{ cartItem.price | money }}</template>
                      <template v-else>{{ cartItem.description }}</template>
                    </p>
                    <p v-if="cartItem.cartable_type == 'App\\Models\\RoomSlot' && ! cartItem.canBeCheckedOut" class="mb-0 font-italic font-weight-bold text-red" data-toggle="tooltip" title="It is likely that this RoomSlot has been purchased by somebody else.">Apologies, this Room Slot is no longer available</p>
                  </div>

                  <div class="row">
                    <div class="col" v-if="! (cartItem.cartable_type == 'App\\Models\\Product' && cartItem.cartable.type == 'CHARGE')">
                      <button class="btn btn-sm btn-red" @click="removeCartItemButton(cartItem, $event)">
                        <span class="material-icons text-white" style="position: relative; top: 4px; right:1px;">delete</span>
                      </button>
                    </div>
                    <div class="col">
                      <img v-if="cartItem.cartable_type == 'App\\Models\\RoomSlot'" :alt="cartItem.cartable.room.name" :src="'/img/mp/mp-ls-' + cartItem.cartable.room.nickname + '.jpg'" width="70" class="ml-2 p-1">
                      <template v-else-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct'" style="vertical-align: middle;">
                        <img :src="location.mpVoucherLandscapeSrc" alt="Gift Voucher" width="70" class="ml-2 p-1">
                      </template>
                      <img v-else-if="cartItem.cartable_type == 'App\\Models\\VirtualGame'" style="vertical-align: middle;" :alt="cartItem.cartable.name" :src="'/img/mp/mp-ls-' + cartItem.cartable.nickname + '.jpg'" width="70" class="ml-2 p-1">
                      <template v-else-if="cartItem.cartable_type == 'App\\Models\\Product'">
                        <img v-if="cartItem.cartable.type == 'ADD_ON'" :src="cartItem.cartable.imageUrl ? cartItem.cartable.imageUrl : '/img/sale/product.jpg'" :alt="cartItem.cartable.name" width="70" class="ml-2 p-1">
                        <img v-else src="/img/sale/product.jpg" :alt="cartItem.cartable.name" width="70" class="ml-2 p-1">
                      </template>
                    </div>
                  </div>

                </td>
                <td style="vertical-align: top;">
                  <div>
                    <template v-if="cartItem.cartable_type == 'App\\Models\\RoomSlot'">
                      <template v-if="pricingStyle == 'CHILD_TOTAL_PLAYERS' || location.location_child_pricing">
                        <p class="mt-1 mb-0">
                          <span>{{ cartItem.options.adults }} <span class="material-icons" style="position: relative; top: 6px;">person</span></span>
                        </p>
                        <div class="btn-group">
                          <button
                            class="btn btn-red"
                            type="button"
                            :disabled="disableReduceAdultQtyButton(cartItem)"
                            @click="itemAdultsChanged(cartItem, -1)">&minus;</button>
                          <button
                            class="btn btn-green"
                            type="button"
                            :disabled="disableIncreaseAdultQtyButton(cartItem)"
                            @click="itemAdultsChanged(cartItem, 1)">&plus;</button>
                        </div>

                        <p class="mb-0">
                          <span style="margin: 0 4.5px;">{{ cartItem.options.children }} <span class="material-icons" style="position: relative; top: 3px; font-size: 95%;">person</span></span>
                        </p>
                        <div class="btn-group mb-2">
                          <button
                            class="btn btn-red"
                            type="button"
                            :disabled="disableReduceChildrenQtyButton(cartItem)"
                            @click="itemChildrenChanged(cartItem, -1)">&minus;</button>
                          <button
                            class="btn btn-green"
                            type="button"
                            :disabled="disableIncreaseChildrenQtyButton(cartItem)"
                            @click="itemChildrenChanged(cartItem, 1)">&plus;</button>
                        </div>
                      </template>
                      <template v-else>
                        <p class="mb-0">
                          <span>{{ cartItem.quantity }} <span class="material-icons" style="position: relative; top: 6px;">person</span></span>
                        </p>
                        <div class="btn-group">
                          <button
                            class="btn btn-red"
                            type="button"
                            :disabled="cartItem.options.children > 0 ? cartItem.options.adults <= 2 || (cartItem.options.children + cartItem.options.adults) <= roomForCartable(cartItem).play_min : roomForCartable(cartItem).play_min == cartItem.quantity"
                            @click="itemAdultsChanged(cartItem, -1)">&minus;</button>
                          <button
                            class="btn btn-green"
                            type="button"
                            :disabled="cartItem.availableRemainingTickets - cartItem.quantity == 0"
                            @click="itemAdultsChanged(cartItem, 1)">&plus;</button>
                        </div>
                      </template>
                    </template>
                    <template v-else-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct' && cartItem.description == 'Money Voucher for 1p'">
                      <p class="mb-0">&times;1</p>
                    </template>
                    <template v-else-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct'">
                      <p class="mb-0">&times;{{ cartItem.quantity }}</p>
                    </template>
                    <template v-else-if="cartItem.cartable_type == 'App\\Models\\Product'">
                      <p class="mb-0">&times;{{ cartItem.quantity }}</p>
                    </template>
                    <template v-else>
                      <p class="mb-0">{{ cartItem.quantity }}</p>
                    </template>
                  </div>
                </td>
                <td style="vertical-align: top;">
                  {{ cartItem.price | money }}
                </td>

              </template>
              <template v-else>

                <td style="vertical-align: middle; width: 30px;" class="text-center">
                  <div class="ml-2" v-if="! (cartItem.cartable_type == 'App\\Models\\Product' && cartItem.cartable.type == 'CHARGE')">
                    <button class="btn btn-sm btn-red" @click="removeCartItemButton(cartItem, $event)">
                      <span class="material-icons text-white" style="position: relative; top: 4px; right:1px;">delete</span>
                    </button>
                  </div>
                </td>

                <td v-if="cartItem.cartable_type == 'App\\Models\\RoomSlot'" style="vertical-align: middle;">
                  <img :alt="cartItem.cartable.room.name" :src="'/img/mp/mp-ls-' + cartItem.cartable.room.nickname + '.jpg'" width="100" class="ml-2 p-1">
                </td>
                <td v-else-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct'" style="vertical-align: middle;">
                  <img :src="location.mpVoucherLandscapeSrc" alt="Gift Voucher" width="100" class="ml-2 p-1">
                </td>
                <td v-else-if="cartItem.cartable_type == 'App\\Models\\VirtualGame'" style="vertical-align: middle;">
                  <img :alt="cartItem.cartable.name" :src="'/img/mp/mp-ls-' + cartItem.cartable.nickname + '.jpg'" width="100" class="ml-2 p-1">
                </td>
                <td v-else-if="cartItem.cartable_type == 'App\\Models\\Product'" style="vertical-align: middle;">
                  <img v-if="cartItem.cartable.type == 'ADD_ON'" :src="cartItem.cartable.imageUrl ? cartItem.cartable.imageUrl : '/img/sale/product.jpg'" :alt="cartItem.cartable.name" width="100" class="ml-2 p-1">
                  <img v-else src="/img/sale/product.jpg" :alt="cartItem.cartable.name" width="100" class="ml-2 p-1">
                </td>

                <td style="vertical-align: middle;">
                  <p class="mb-0">
                    <template v-if="cartItem.cartable_type == 'App\\Models\\Product'">
                      <template v-if="cartItem.description == 'Booking fee'">
                        Booking Fee
                      </template>
                      <template v-else>
                        AddOn: {{ cartItem.descriptionShort }}
                      </template>
                    </template>
                    <template v-else-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct' && cartItem.description == 'Money Voucher for 1p'">Money Voucher for {{ cartItem.price | money }}</template>
                    <template v-else>{{ cartItem.description }}</template>
                  </p>
                  <p v-if="cartItem.cartable_type == 'App\\Models\\RoomSlot' && ! cartItem.canBeCheckedOut" class="mb-0 font-italic font-weight-bold text-red" data-toggle="tooltip" title="It is likely that this RoomSlot has been purchased by somebody else.">Apologies, this Room Slot is no longer available</p>
                </td>

                <td style="vertical-align: middle; min-width: 160px">
                  <template v-if="cartItem.cartable_type == 'App\\Models\\RoomSlot'">
                    <template v-if="pricingStyle == 'CHILD_TOTAL_PLAYERS' || location.location_child_pricing">
                      <p class="mt-1 mb-2">
                        <button
                          class="btn btn-red"
                          type="button"
                          :disabled="disableReduceAdultQtyButton(cartItem)"
                          @click="itemAdultsChanged(cartItem, -1)">&minus;</button>

                        <span>{{ cartItem.options.adults }} <span class="material-icons" style="position: relative; top: 6px;">person</span></span>

                        <button
                          class="btn btn-green"
                          type="button"
                          :disabled="disableIncreaseAdultQtyButton(cartItem)"
                          @click="itemAdultsChanged(cartItem, 1)">&plus;</button>
                      </p>
                      <p class="mb-1">
                        <button
                          class="btn btn-red"
                          type="button"
                          :disabled="disableReduceChildrenQtyButton(cartItem)"
                          @click="itemChildrenChanged(cartItem, -1)">&minus;</button>

                        <span style="margin: 0 4.5px;">{{ cartItem.options.children }} <span class="material-icons" style="position: relative; top: 3px; font-size: 95%;">person</span></span>

                        <button
                          class="btn btn-green"
                          type="button"
                          :disabled="disableIncreaseChildrenQtyButton(cartItem)"
                          @click="itemChildrenChanged(cartItem, 1)">&plus;</button>
                      </p>
                    </template>
                    <template v-else>
                      <p class="mb-0">
                        <button
                          class="btn btn-red"
                          type="button"
                          :disabled="cartItem.options.children > 0 ? cartItem.options.adults <= 2 || (cartItem.options.children + cartItem.options.adults) <= roomForCartable(cartItem).play_min : roomForCartable(cartItem).play_min == cartItem.quantity"
                          @click="itemAdultsChanged(cartItem, -1)">&minus;</button>
                        <span>{{ cartItem.quantity }} <span class="material-icons" style="position: relative; top: 6px;">person</span></span>
                        <button
                          class="btn btn-green"
                          type="button"
                          :disabled="cartItem.availableRemainingTickets - cartItem.quantity == 0"
                          @click="itemAdultsChanged(cartItem, 1)">&plus;</button>
                      </p>
                    </template>
                  </template>
                  <template v-else-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct' && cartItem.description == 'Money Voucher for 1p'">
                    <p class="mb-0">&times;1</p>
                  </template>
                  <template v-else-if="cartItem.cartable_type == 'App\\Models\\VoucherProduct'">
                    <p class="mb-0">&times;{{ cartItem.quantity }}</p>
                  </template>
                  <template v-else-if="cartItem.cartable_type == 'App\\Models\\Product'">
                    <p class="mb-0">&times;{{ cartItem.quantity }}</p>
                  </template>
                  <template v-else>
                    <p class="mb-0">{{ cartItem.quantity }}</p>
                  </template>
                </td>
                <td style="vertical-align: middle;">
                  {{ cartItem.price | money }}
                </td>

              </template>
            </tr>
          </template>
          <tr>
            <td :colspan="($mq == 'xs' || $mq == 'sm' || $mq == 'md') ? 1 : 3">
              <div class="my-2">
                <div class="btn-group ml-2">
                  <button @click="goToCheckout" class="btn btn-tempus-blue-200" :class="($mq == 'xs' || $mq == 'sm' || $mq == 'md') ? 'btn-sm' : 'btn-lg'">
                    Checkout <span class="material-icons" style="position: relative; top: 5px;">shopping_cart_checkout</span>
                  </button>
                  <button @click="emptyCart" class="btn btn-red" :class="($mq == 'xs' || $mq == 'sm' || $mq == 'md') ? 'btn-sm' : 'btn-lg'">
                    Empty Cart <span class="material-icons" style="position: relative; top: 5px;">remove_shopping_cart</span>
                  </button>
                </div>
              </div>
            </td>
            <td class="font-weight-bold text-right">Total:&nbsp;&nbsp;&nbsp;</td>
            <td class="font-weight-bold">{{ cart.price | money }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    cart: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
  },

  data() {
    return {

    };
  },

  model: {
    event: 'change',
    prop: 'cart',
  },

  computed: {
    sortedCartItems() {
      // first extract all RoomSlots
      let roomSlotCartItems = this.cart.cart_items.filter(ci => ci.cartable_type == "App\\Models\\RoomSlot").sort((a, b) => moment(a.cartable.start) - moment(b.cartable.start));
      let otherCartItems = this.cart.cart_items.filter(ci => ci.cartable_type != "App\\Models\\RoomSlot").sort((a, b) => a.cartable_type - b.cartable_type);

      return roomSlotCartItems.concat(otherCartItems);
    },
  },

  watch: {

  },

  methods: {
    disableReduceAdultQtyButton(cartItem) {
      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        return cartItem.quantity == this.roomForCartable(cartItem).play_min || cartItem.options.adults == 1;
      }
      return cartItem.options.children > 0 ? cartItem.options.adults <= 2 || (cartItem.options.children + cartItem.options.adults) <= this.roomForCartable(cartItem).play_min : this.roomForCartable(cartItem).play_min == cartItem.quantity;
    },

    disableIncreaseAdultQtyButton(cartItem) {
      if (this.consoleDebug) console.log('BookingCheckoutCartSummaryHeader::disableIncreaseAdultQtyButton', cartItem);
      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        if (this.consoleDebug) console.log('BookingCheckoutCartSummaryHeader::disableIncreaseAdultQtyButton', cartItem.cartable.availableRemainingTickets, cartItem.quantity, cartItem.cartable.availableRemainingTickets - cartItem.quantity);
        return cartItem.cartable.availableRemainingTickets - cartItem.quantity == 0;
      }
      return cartItem.cartable.availableRemainingTickets - cartItem.quantity <= 0;
    },

    disableReduceChildrenQtyButton(cartItem) {
      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        return cartItem.quantity == this.roomForCartable(cartItem).play_min || cartItem.options.children == 0;
      }
      return cartItem.options.children == 0 || (cartItem.options.children > 0 ? (cartItem.options.children + cartItem.options.adults) <= this.roomForCartable(cartItem).play_min : this.roomForCartable(cartItem).play_min == cartItem.quantity);
    },

    disableIncreaseChildrenQtyButton(cartItem) {
      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        return cartItem.cartable.availableRemainingTickets - cartItem.quantity == 0;
      }
      return cartItem.cartable.availableRemainingTickets - cartItem.quantity <= 0;
    },

    roomForCartable(cartItem) {
      // console.log('BookingCheckoutCartSummaryHeader::roomForCartable', cartItem);
      if (cartItem.cartable_type == "App\\Models\\RoomSlot") {
        return cartItem.cartable.room;
      }
      return null;
    },

    updateCartItem(cartItem) {
      if (this.consoleDebug) console.log('BookingCheckoutCartSummaryHeader::updateCartItem')
      var request = {
        location: this.location.slug,
        quantity: cartItem.quantity,
        options: cartItem.options,
        notes: cartItem.notes,
      };

      this.loading(true, this.$refs.cartSummaryHeader);

      axios.patch(this.route('api.cart.cart-items.update', {cart: this.cart, cartItem: cartItem}), request)
        .then((response) => {
          if (response.status == 200) {
            this.$emit('change', response.data);
          } else {
            flash('Error updating Item', 'danger');
            console.log('updateItem', response.data);
            console.log('updateItem', response.status);
            console.log('updateItem', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error updating Item', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('updateItem:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('updateItem:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('updateItem:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('updateItem:401', error.response.data);
            } else {
              console.log('updateItem: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('updateItem: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('updateItem: Error', error.message);
          }
          this.loading(false);
        });
    },

    itemAdultsChanged(cartItem, amount) {
      if (this.consoleDebug) console.log('BookingCheckoutCartSummaryHeader::itemAdultsChanged', cartItem, amount);

      cartItem.options.adults = parseInt(cartItem.options.adults) + parseInt(amount);
      cartItem.quantity = parseInt(cartItem.quantity) + parseInt(amount);

      // var cartItemIndex = this.cart.cart_items.findIndex(ci => ci.id == cartItem.id);
      // Vue.set(this.cart.cart_items, 'subtitlesArray', output);

      this.updateCartItem(cartItem);
    }, // itemAdultsChanged()

    itemChildrenChanged(cartItem, amount) {
      // console.log('itemChildrenChanged', amount);
      cartItem.options.children = parseInt(cartItem.options.children) + parseInt(amount);
      cartItem.quantity = parseInt(cartItem.quantity) + parseInt(amount);

      this.updateCartItem(cartItem);

    }, // itemChildrenChanged()

    goToCheckout() {
      if (this.consoleDebug) console.log('BookingCheckoutCartSummaryHeader::goToCheckout');
      this.$emit('go-to-checkout');
    },

    emptyCart() {
      if (this.consoleDebug) console.log('BookingCheckoutCartSummaryHeader::emptyCart');
      this.$emit('empty-cart');
    },

    removeCartItemButton(cartItem, event) {
      // console.log('BookingCheckoutCartSummaryHeader::removeCartItemButton', cartItem);

      const self = this;

      $('.destroy-cart-item').confirmation('dispose');
      $('.destroy-cart-item').removeClass('destroy-cart-item');
      event.target.classList.add('destroy-cart-item');

      // confirmation popover
      let options = {
        container: 'body',
        rootSelector: '.destroy-cart-item',
        title: 'Delete this item?',
        popout: true,
        singleton: true,
        btnOkClass: 'btn btn-sm btn-green',
        btnCancelClass: 'btn btn-sm btn-red',
        placement: 'right',
        trigger: 'manual',
        onConfirm(value) {
          event.target.classList.remove('destroy-cart-item');

          self.$nextTick(function () {
            self.cartRemoveCartItem(cartItem);
          });
        },
        onCancel(value) {
          event.target.classList.remove('destroy-cart-item');
        },
      };

      $('.destroy-cart-item').confirmation(options);
      $('.destroy-cart-item').on('hidden.bs.confirmation', function (event) {
        event.target.classList.remove('destroy-cart-item');
      });
      $('.destroy-cart-item').confirmation('show');
    },

    cartRemoveCartItem(cartItem) {
      if (this.consoleDebug) console.log('BookingCheckoutCartSummaryHeader::cartRemoveCartItem(cartItem)', cartItem);

      let request = {
        location: this.location.slug,
      }

      this.loading(true);
      axios.delete(this.route('api.cart.cart-items.destroy', {cart: this.cart, cartItem: cartItem}), {data: request})
        .then((response) => {
          if (response.status == 200) {
            if (this.consoleDebug) console.log('BookingCheckoutCartSummaryHeader::cartRemoveCartItem - axios result')
            var cart = response.data;
            this.$emit('change', cart);
          } else {
            flash('Error removing RoomSlot from Cart', 'danger');
            console.log('cartRemoveRoomSlot', response.data);
            console.log('cartRemoveRoomSlot', response.status);
            console.log('cartRemoveRoomSlot', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error removing RoomSlot from Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartRemoveCartItem:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartRemoveCartItem:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartRemoveCartItem:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartRemoveCartItem:401', error.response.data);
            } else {
              console.log('cartRemoveCartItem: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartRemoveCartItem: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartRemoveCartItem: Error', error.message);
          }
          this.loading(false);
        });
    },
  },

  mounted() {
  },
}
</script>
